export default {
  cloudName: 'gonuvem',
  apiKey: '212628251629853',
  uploadPreset: 'digala_preset',
};
